export default [
  {
    title: 'Palo Alto Little League',
    content:
      'We have used UmpCast for the past 2 seasons. We have successfully used it to help facilitate our junior umpires program',
    customerName: 'Steveeeeee Vonderharrrrr',
    customerTitle: 'Director of Research and Data at Palo Alto Little League',
    customerImage: 'https://placeimg.com/150/150/people'
  },
  {
    title: 'Peninsula Baseball Umpires Association',
    content:
      'We have used UmpCast for 1 full season. We managed hundreds of umpires and loved that it was super easy to use!',
    customerName: 'Barrrrrrryyyyy Harissss',
    customerTitle: 'Director of Research and Data at PBUA',
    customerImage: 'https://placeimg.com/150/150/people'
  }
];
